import { Box, Flex, Spacer } from '@chakra-ui/react';
import { Button, Text } from '@diamond/shared/ui';
import { buyerCurrencyFormatter } from '@diamond/shared/utils';
import Link from 'next/link';
import { memo, useMemo } from 'react';

import { InvoiceButton } from './invoice-button';
import { PaymentActions } from './payment-actions';
import { OrderSummaryProps } from './types';

const OrderSummary = memo(
  ({ data, selectedShipToId, isMobile }: OrderSummaryProps) => {
    const showInvoiceButton = useMemo(() => {
      return (
        data.invoice_link &&
        (data.status === 'received' || data.status === 'partially_received')
      );
    }, [data.invoice_link, data.status]);

    const orderDetailLink = `/order-detail/${data.order_meta_id}?warehouse=${selectedShipToId}`;

    return (
      <Flex
        direction="row"
        rounded="lg"
        border="1px"
        borderColor="gray.33"
        shadow="base"
        bg={{ base: '#F3F4F5', md: 'unset' }}
        p={{ base: '2', md: '4' }}
        mt="4"
      >
        <Flex justifyContent="space-between">
          <Box flex="1">
            <Text color="gray.75" fontSize={{ base: '0.5rem', md: 'md' }}>
              Total Tagihan
            </Text>
            <Text fontWeight="bold" fontSize={{ base: 'sm', md: 'xl' }}>
              {buyerCurrencyFormatter(data.subtotal)}
            </Text>
          </Box>
        </Flex>
        <Spacer />
        <Flex gap="5" alignItems="center">
          <Box display={{ base: 'none', md: 'flex' }}>
            <PaymentActions
              data={data}
              selectedShipToId={selectedShipToId}
              isMobile={isMobile}
            />
          </Box>
          <Flex gap="1" alignItems="center">
            <Box w="full" alignItems="center">
              <Link href={orderDetailLink}>
                <Button
                  type="button"
                  size={{ base: 'xs', md: 'md' }}
                  p="1rem"
                  className="btn-see-detail"
                  w="full"
                  bg="white"
                  fontSize={{ base: '0.5rem !important', md: 'md !important' }}
                >
                  Lihat Pesanan
                </Button>
              </Link>
            </Box>
            {showInvoiceButton && (
              <Box
                id="btn-invoice-sm"
                h="full"
                display={{ base: 'block', md: 'none' }}
                alignItems="center"
              >
                <InvoiceButton link={data.invoice_link ?? ''} />
              </Box>
            )}
            {showInvoiceButton && (
              <Box
                id="btn-invoice"
                h="full"
                display={{ base: 'none', md: 'block' }}
                alignItems="center"
              >
                <InvoiceButton link={data.invoice_link ?? ''} />
              </Box>
            )}
          </Flex>
        </Flex>
      </Flex>
    );
  }
);

OrderSummary.displayName = 'OrderSummary';

export { OrderSummary };
